import Layout from "../components/layout";
import * as React from "react";
import {useEffect, useState} from "react";
import GuestInput from "../components/GuestInput";
import RadioButton from "../components/RadioButton";
import {FaPlus} from "react-icons/fa";
import Modal from "../components/modal";

const RSVPPage = () => {

  const [isAttending, setAttending] = useState(true);
  const [form, setForm] = useState({
    attendance: 'yes',
    guests: [
      { name: '', food: 'vegetarisch', brunch: true }
    ],
    message: ''
  });

  const [modal, setModal] = useState({
    title: "",
    message: "",
    hidden: true
  })

  const [isDisabled, setDisabled] = useState(true);

  useEffect(() => {
    setAttending(form.attendance === 'yes');
  }, [form.attendance]);

  useEffect(() => {
    const disabled = !form.guests.filter(g => !!g.name).length;
    setDisabled(disabled);
  }, [form])

  const formSpark = (form) => {
    const submission = {
      Anwesenheit: form.attendance === 'yes' ? 'Ja' : 'Nein'
    };
    if (form.message) {
      submission['Nachricht'] = form.message;
    }
    if (isAttending) {
      form.guests
        .filter(guest => !!guest.name)
        .forEach(guest => {
          submission[guest.name] = {
            food: guest.food,
            brunch: guest.brunch ? 'ja' : 'nein'
          };
        });
    } else {
      submission.guests = form.guests.map(g => g.name)
    }
    return JSON.stringify(submission);

  }

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    try {
      await sendToFormSpark(form);
      let title = 'Schade';
      let message = 'Aber vielen Dank für die Rückmeldung!!!';
      if (form.attendance === 'yes') {
        title = 'Danke'
        message = 'Wir freuen uns sehr auf dich / euch!!!';
      }
      setModal({
        hidden: false,
        title,
        message
      });
      setForm({
        attendance: 'yes',
        guests: [
          { name: '', food: 'vegetarisch', brunch: true }
        ],
        message: ''
      })
    } catch (error) {
      alert('Oh, das ist was schief gelaufen! Die Antwort konnte nicht geschickt werden, tut uns leid...')
    }
  }

  const sendToFormSpark = async (form) => {
    if (!process.env.GATSBY_RSVP_FORM_URL) {
      return;
    }
    const res = await fetch(process.env.GATSBY_RSVP_FORM_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: formSpark(form)
    });
    if (!res.ok) {
      throw Error('Something went wrong');
    }
  }

  const handleChange = (ev) => {
    setForm({
      ...form,
      [ev.target.name]: ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value
    })
  }

  const handleGuestChange = (id, guest) => {
    const guests = [...form.guests];
    guests[id] = guest;
    setForm({
      ...form,
      guests
    });
  }

  const addGuest = (ev) => {
    ev.preventDefault();
    const guests = [...form.guests];
    guests.push({ name: '', food: 'vegetarisch', brunch: true });
    setForm({
      ...form,
      guests
    });
  }

  const deleteGuest = (id) => {
    const guests = [...form.guests];
    guests.splice(id, 1);
    setForm({
      ...form,
      guests
    })
  }

  const handleModalDismiss = () => {
    setModal({
      hidden: true,
      message: '',
      title: ''
    });
  }

  return (
    <>
      <Layout title={'Rückmeldung'}>
        <section className="p-8">
          <h1 className="text-3xl sm:text-5xl uppercase tracking-wider">
            Kommst du? / kommt ihr?
          </h1>

          <form name="rsvp" className={"flex flex-col gap-8 md:gap-4 text-base sm:text-lg"} onSubmit={handleSubmit}>
            <h2>Bitte sag/sagt uns bis zum 15.01. Bescheid!</h2>
            <div className={"flex flex-row gap-2 mt-4"}>
              <RadioButton name="attendance"
                           value="yes"
                           label="Ja, dabei!"
                           checked={form.attendance === 'yes'}
                           onChange={handleChange}/>
              <RadioButton name="attendance"
                           value="no"
                           label="Leider nicht dabei"
                           checked={form.attendance === 'no'}
                           onChange={handleChange}/>
            </div>
            { form.guests.map((guest, index) => {
              return <GuestInput key={`guest-${index}`}
                                 id={index}
                                 guest={guest}
                                 isAttending={isAttending}
                                 canDelete={form.guests.length > 1}
                                 onGuestChange={handleGuestChange}
                                 onGuestDelete={deleteGuest}/>
            })}
            {
              form.guests.length < 10 &&
              <button onClick={addGuest}
                      className={"border border-primary px-4 py-2 text-sm rounded self-center flex items-center gap-1"}>
                <FaPlus/>
                <div>Weiteren Gast hinzufügen</div>
              </button>
            }
            <textarea name={"message"}
                      value={form.message}
                      onChange={handleChange}
                      rows={4}
                      placeholder={"Deine Nachricht"}/>
            <input className="p-4 font-bold font-pretty cursor-pointer border border-primary text-white bg-primary disabled:opacity-75 disabled:cursor-default"
                   disabled={isDisabled}
                   type="submit"
                   value="Abschicken"/>
          </form>
        </section>
      </Layout>
      <Modal hidden={modal.hidden} onDismiss={handleModalDismiss}>
        <h1 className={"font-pretty capitalize mb-8"}>{modal.title}</h1>
        <p>{modal.message}</p>
        <p className={"mt-2 text-base"}>PS: Schon das Minigame auf der Seite entdeckt?</p>
      </Modal>
    </>
  )
}

export default RSVPPage
